module.exports = __webpack_public_path__ + "static/media/canvas-1.491127ef.png";